import { FC, forwardRef, ReactNode } from 'react'
import { Smile } from 'lucide-react'
import { useSelector } from 'react-redux'
import { emojisSlice } from 'components/emojis/emojisSlice'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@wellesley/ui'
import {
  EmojiPicker,
  EmojiClickData,
  EmojiStyle,
} from '@wellesley/emoji-picker'

export type TEmojiDropdown = {
  trigger?: ReactNode
  width?: number
  disabled?: boolean
  onEmojiClick(this: void, data: EmojiClickData): void
}

const EmojiPickerContent: FC<TEmojiDropdown> = ({ width, onEmojiClick }) => {
  const emojis = useSelector(emojisSlice.selectors.selectEmojis)

  const customEmoji = emojis.map((e) => ({
    names: [e.shortcode],
    id: e.shortcode,
    imgUrl: e.staticUrl,
    category: `${e.category?.[0]?.toUpperCase()}` + e.category?.slice(1),
  }))

  return (
    <EmojiPicker
      lazyLoadEmojis
      skinTonesDisabled
      width={width}
      height={260}
      previewConfig={{
        showPreview: false,
      }}
      customEmojis={customEmoji}
      onEmojiClick={onEmojiClick}
      autoFocusSearch={false}
      emojiStyle={EmojiStyle.NATIVE}
    />
  )
}

const EmojiDropdown = forwardRef<HTMLButtonElement, TEmojiDropdown>(
  ({ trigger, disabled, ...props }, ref) => {
    return (
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger ref={ref} disabled={disabled} asChild>
          {trigger || (
            <button className="text-gray-500 hover:text-blue-500 disabled:text-gray-300 [&[data-state=open]]:text-blue-500">
              <Smile size={24} />
            </button>
          )}
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <EmojiPickerContent width={355} {...props} />
        </DropdownMenuContent>
      </DropdownMenu>
    )
  },
)

EmojiDropdown.displayName = 'EmojiDropdown'

export { EmojiDropdown, EmojiPickerContent }
